export default __webpack_public_path__ + "static/media/delegate.5ca9e748.gif";